import React from "react";
import "./HeroStatic2.css";
import parse from "html-react-parser";
import { APP_COLORS } from "../../constants/styles";

function HeroStatic2({ heading, body, section_image, colors: colorObj }) {
    return (
        <>
            <div className="row" style={APP_COLORS(colorObj)}>
                <div className="col-12">
                    <div className="HeroStaticWrapper" data-aos="fade-up">
                        <img src={section_image?.src}></img>
                        <div className="contMain container">
                            <h2>{heading}</h2>
                            <p>{body && parse(body)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default HeroStatic2;
